"use client"; // Ensures it only runs on the client side

import { useEffect } from "react";

const ChatPod = () => {
    useEffect(() => {
        if (typeof window === "undefined") return; // Ensure it runs only on the client side

        (function (w, d, x, id) {
            const script = d.createElement("script");
            script.src = "https://db08fjupg2abb.cloudfront.net/amazon-connect-chat-interface-client.js";
            script.async = true;
            script.id = id;
            d.getElementsByTagName("head")[0].appendChild(script);

            w[x] =
                w[x] ||
                function () {
                    (w[x].ac = w[x].ac || []).push(arguments);
                };
        })(window, document, "amazon_connect", "8ebaaba9-808a-4e53-bd5f-f31af071e1ef");

        (window as any).amazon_connect("styles", {
            iconType: "CHAT",
            openChat: { color: "#ffffff", backgroundColor: "#1a8cff" },
            closeChat: { color: "#ffffff", backgroundColor: "#1a8cff" },
        });

        (window as any).amazon_connect(
            "snippetId",
            "QVFJREFIZ2ZYaENvQWJCb1ZtYmxRNlFMNVJYMlhab3BKY1p0RnRGQ2pJNGhxdnBvemdIY3l5NGVoWXlNZ3Erc055bHlDbnVpQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNZ3luVW0zcEVWQUVXaUs5dkFnRVFnQ3RRbGdobXgwOGtoMjFWeUJCTXhEbWlZRHBLeFVrOERuQU1Ma2p2LzNBTmU4NHBtWkhhKzZYR3lXTys6OkNwRzNCMUo4MTE5dEZDeUpWNEgzZUdLMVFocjlJMCtDVFBveDNXYUFUOW55dXlpd1lrYURYMm12VVlIVU0vcWMxSUoza2Y0TTVhRWhtTVduSHhGeUFlVzRxRC9IcGM3RGgzWWl4MXBvdi9jKzRXdW1CdWhjUm8rS2xGUXcyY1lON1JOT3BUMTV5ZlpOdlJDTEZ2NXMvSDZPZ1hLdENhRT0="
        );

        (window as any).amazon_connect("supportedMessagingContentTypes", [
            "text/plain",
            "text/markdown",
            "application/vnd.amazonaws.connect.message.interactive",
            "application/vnd.amazonaws.connect.message.interactive.response",
        ]);
    }, []);

    return null; // No UI needed, just injecting the script
};

export default ChatPod;
